<template>
  <div>
    <BSButton ref='bsButton' @notice='notice' :addDeviceBtn='true' :delDeviceBtn='true' :upGradeBtn='true' :downGradeBtn='true' :synVersionBtn='true'></BSButton>
    <template>
      <div id='bsTableList' class='h100vh-140'>
        <div class='h100vh-140'>
          <ejs-grid ref='grid' :dataSource='BSDeviceData' height='calc(100% - 0px)' allowReordering='true' allowResizing='true' allowExcelExport='true' allowTextWrap='true'>
            <e-columns>
              <e-column field='state' :headerText='deviceState' width='100' textAlign='Center'></e-column>
              <e-column field='name' :headerText='deviceName' width='150' textAlign='Center'></e-column>
              <e-column field='runVersion' :headerText='deviceRunVersion' width='150' textAlign='Center'></e-column>
              <e-column field='saveVersion' :headerText='deviceSaveVersion' width='150' textAlign='Center'></e-column>
              <e-column field='localVersion' :headerText='deviceLocalVersion' width='150' textAlign='Center'></e-column>
              <e-column field='deviceType' :headerText='deviceType' width='150' textAlign='Center'></e-column>
              <e-column field='createTime' :headerText='deviceCreateTime' width='150' textAlign='Center'></e-column>
              <e-column field='synSuccessTime' :headerText='deviceSynSuccessTime' width='150' textAlign='Center'></e-column>
            </e-columns>
          </ejs-grid>
          <ejs-pager ref='pager' @click='getBSDeviceList()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
        </div>
      </div>
    </template>
    <!-- 添加设备对话框 -->
    <CustomDialog ref='deviceDialog' :element='devDialog.element' :styles='devDialog.styles' :messages='devDialog.messages'>
      <template v-slot:dialog-content>
        <addBSDevice ref='addDev' @close='addCancel' ></addBSDevice>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
  import CustomDialog from '../../../common/CustomDialog';
  import BSButton from '@/components/deploymentManagement/runningEnvironment/BSDeviceEnviromentConfig/BSButton';
  import BSTable from '@/components/deploymentManagement/runningEnvironment/BSDeviceEnviromentConfig/BSTable';
  import AddBSDevice from '@/components/deploymentManagement/runningEnvironment/BSDeviceEnviromentConfig/AddBSDevice';
  import { EventBus } from '../../../../plugins/eventBus';
  export default {
    name: "BSDeviceEnvironment",
    components: {
      CustomDialog,
      BSButton,
      BSTable,
      AddBSDevice,
    },
    mounted() {
      this.getBSDeviceList();
    },
    data() {
      return {
        searchString: '', // 搜索字符串
        BSDeviceData:[],  // 基站设备数据源
        page: {           // 分页数据
          pageNo: 1,
          pageSize: 20,
          totalCount: 0,
          pageCount: 10
        },
        deviceState: '状态',
        deviceName: '名称',
        deviceRunVersion: '运行版本',
        deviceSaveVersion: '存储版本',
        deviceLocalVersion: '本地版本',
        deviceType: '类型',
        deviceCreateTime: '创建时间',
        deviceSynSuccessTime: '同步成功时间',
        devDialog: {
          element: {
            title: this.$t('Topo.devAdd'),
            // target: '#app',
            isClose: true,
            refName: this.$t('Topo.devMange'),
            buttonGroup: [
              { click: this.addCancel, buttonModel: { content: this.$t('Topo.cancel') } },
              { click: this.addSubmit, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } },
            ]
          },
          styles: {
            width: '680px',
            height: '460px',
            visible: false,
            model: true
          },
          messages: {
            title: this.$t('Topo.devAdd')
          }
        },
      }
    },
    methods: {
      notice(type) {
        switch (type) {
          case 'addDevice':
            this.addDevice();
            break;
          case 'delDevice':

            break;
          case 'upGrade':

            break;
          case 'downGrade':

            break;
          case 'synVersion':

            break;

          default:
            break;
        }
      },
      // 初始化表格数据
      getBSDeviceList() {
        const This = this;
        This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
        this.$axios.get(`/lte/ems/topo/ne/nePage?pageNo=${This.page.pageNo}&pageSize=${This.page.pageSize}&name=${This.searchValue}`).then((response) => {
          if (response.data && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            This.BSDeviceData = response.data.resultVal.result;
            This.page.totalCount = response.data.resultVal.totalCount;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
      },
      // 模糊搜索
      searchMethod() {
        const This = this;
        if(This.searchString !==''){   //模糊搜索时页面初始化
          This.page.pageNo = 1;
        }
        else{
          This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
        }
        this.$axios.get(`/lte/ems/topo/ne/nePage?pageNo=${This.page.pageNo}&pageSize=${This.page.pageSize}&name=${This.searchString}`).then((response) => {
          if (response.data && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            This.BSDeviceData = response.data.resultVal.result;
            This.page.totalCount = response.data.resultVal.totalCount;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
      },
      // 打开弹窗
      addDevice() {
        this.$refs.addDev.initData();
        this.$refs.deviceDialog.show();
        this.$refs.addDev.bindValidate();
      },
      // 取消
      addCancel() {
        this.$refs.deviceDialog.clear();
        this.$refs.deviceDialog.close();
      },

    },
  }
</script>

